<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p style="text-align:center">In memoriam to my mother,</p>
<p style="text-align:center">Siria,</p>
<p style="text-align:center">who was my role model in education.</p>
<p style="text-align:center">To my wife, Gladys, who has made my life so much worth living in such a complete way.</p>
<p style="text-align:center">To my children,</p>
<p style="text-align:center">Rosita and Tonito,</p>
<p style="text-align:center">whom I love with all my heart.</p>
<p style="text-align:center">To my friends</p>
<p style="text-align:center">in Cuba, Mexico, and</p>
<p style="text-align:center">the United States.</p><br/>
<p style="text-align:center">“Social prosperity means man happy, the citizen free, the nation great.”</p>
<p style="text-align:right">– Victor Hugo, <em>Les Miserables</em>, Saint Denis, book I, Chapter 4</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?747d79ea